@if (pageTimingOut) {
  <div class="govuk-notification-banner" role="alert" aria-labelledby="govuk-notification-banner-title">
  <div class="govuk-notification-banner__header">
    <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
      Important
    </h2>
  </div>
  <div class="govuk-notification-banner__content">
    <p class="govuk-notification-banner__heading">
      Your page will time out in 5 minutes
    </p>
    <button class="govuk-button govuk-button--inverse" data-module="govuk-button" (click)="extendSession()">Stay on this page</button>
  </div>
</div>
}